// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overview */
.eg-overview {
    max-width: 800px;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 32px;
    margin-bottom: 40px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
    text-align: center;
  }
  
  .eg-overview h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 16px;
    color: #222;
  }
  
  .eg-overview p {
    font-size: 1rem;
    line-height: 1.6;
    color: #444;
    max-width: 700px;
    margin: 0 auto;
  }
  
  /* Hero (unchanged) */
  .eg-hero {
    width: 100%;               /* allow it to shrink */
    max-width: 800px;          /* or whatever your ideal line-length is */
    margin: 0 auto 60px;       /* top 0, auto left/right, bottom 60px */
    text-align: center;        /* center all its content */
  }
  .eg-hero h1 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-top: 30px;
    margin-bottom: 16px;
    color: #FFF;
  }
  
  .eg-subhead {
    font-size: 1.125rem;
    margin-bottom: 32px;
    line-height: 1.5;
    color: #888;
  }
  
  /* Features Grid (unchanged) */
  /* Align cards under the hero section */
.eg-features {
    max-width: 800px;               /* match your .eg-hero max-width */
    margin: 0 auto 60px;            /* auto left/right centers it */
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 32px;
    width: 100%;
  }
  .eg-hero,
.eg-features {
  padding: 0 20px;                /* same horizontal padding */
}

  
  .eg-feature-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    padding: 24px;
    text-align: center;
    transition: transform 0.15s ease;
  }
  
  .eg-feature-card:hover {
    transform: translateY(-4px);
  }
  
  .eg-feature-icon {
    color: #FFD000;
    font-size: 2rem;
    margin-bottom: 12px;
  }
  
  .eg-feature-card h3 {
    font-size: 1.125rem;
    margin-bottom: 8px;
    font-weight: 600;
  }
  
  .eg-feature-card p {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.4;
  }
  
  /* Responsive tweaks */
  @media (max-width: 600px) {
    .eg-overview {
      padding: 24px;
      margin-bottom: 24px;
    }
    .eg-overview h2 {
      font-size: 1.5rem;
    }
    .eg-hero h1 {
      font-size: 2rem;
    }
    .eg-subhead {
      font-size: 1rem;
    }
  }
  
.eg-hero-header {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    margin-top: 30px;
  }
  
  .eg-info-icon {
    font-size: 1.2rem;
    color: #FFD000;
    cursor: pointer;
    transition: color .2s;
  }
  .eg-info-icon:hover {
    color: #e6c000;
  }
  
  /* Modal overlay */
  .eg-modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }
  
  /* Modal box */
  .eg-modal {
    background: #fff;
    border-radius: 8px;
    padding: 32px;
    max-width: 600px;
    width: 90%;
    position: relative;
    box-shadow: 0 6px 24px rgba(0,0,0,0.2);
    text-align: left;
  }
  
  /* Close button */
  .eg-modal-close {
    position: absolute;
    top: 12px; right: 12px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #888;
  }
  .eg-modal-close:hover {
    color: #333;
  }
  
  /* Modal content */
  .eg-modal h2 {
    margin-top: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: #222;
  }
  .eg-modal p {
    margin: 16px 0 0;
    font-size: 1rem;
    line-height: 1.6;
    color: #444;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/enterprise-gateway.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,WAAW,gBAAgB,uBAAuB;IAClD,gBAAgB,WAAW,0CAA0C;IACrE,mBAAmB,QAAQ,wCAAwC;IACnE,kBAAkB,SAAS,2BAA2B;EACxD;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA,8BAA8B;EAC9B,uCAAuC;AACzC;IACI,gBAAgB,gBAAgB,kCAAkC;IAClE,mBAAmB,aAAa,+BAA+B;IAC/D,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;EACb;EACA;;EAEA,eAAe,iBAAiB,4BAA4B;AAC9D;;;EAGE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,aAAa;MACb,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;;AAEF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,MAAM,EAAE,OAAO;IACf,WAAW,EAAE,YAAY;IACzB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA,cAAc;EACd;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS,EAAE,WAAW;IACtB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb","sourcesContent":["/* Overview */\n.eg-overview {\n    max-width: 800px;\n    width: 100%;\n    background: #fff;\n    border-radius: 8px;\n    padding: 32px;\n    margin-bottom: 40px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.06);\n    text-align: center;\n  }\n  \n  .eg-overview h2 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin-bottom: 16px;\n    color: #222;\n  }\n  \n  .eg-overview p {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #444;\n    max-width: 700px;\n    margin: 0 auto;\n  }\n  \n  /* Hero (unchanged) */\n  .eg-hero {\n    width: 100%;               /* allow it to shrink */\n    max-width: 800px;          /* or whatever your ideal line-length is */\n    margin: 0 auto 60px;       /* top 0, auto left/right, bottom 60px */\n    text-align: center;        /* center all its content */\n  }\n  .eg-hero h1 {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-top: 30px;\n    margin-bottom: 16px;\n    color: #FFF;\n  }\n  \n  .eg-subhead {\n    font-size: 1.125rem;\n    margin-bottom: 32px;\n    line-height: 1.5;\n    color: #888;\n  }\n  \n  /* Features Grid (unchanged) */\n  /* Align cards under the hero section */\n.eg-features {\n    max-width: 800px;               /* match your .eg-hero max-width */\n    margin: 0 auto 60px;            /* auto left/right centers it */\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 32px;\n    width: 100%;\n  }\n  .eg-hero,\n.eg-features {\n  padding: 0 20px;                /* same horizontal padding */\n}\n\n  \n  .eg-feature-card {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n    padding: 24px;\n    text-align: center;\n    transition: transform 0.15s ease;\n  }\n  \n  .eg-feature-card:hover {\n    transform: translateY(-4px);\n  }\n  \n  .eg-feature-icon {\n    color: #FFD000;\n    font-size: 2rem;\n    margin-bottom: 12px;\n  }\n  \n  .eg-feature-card h3 {\n    font-size: 1.125rem;\n    margin-bottom: 8px;\n    font-weight: 600;\n  }\n  \n  .eg-feature-card p {\n    font-size: 0.95rem;\n    color: #555;\n    line-height: 1.4;\n  }\n  \n  /* Responsive tweaks */\n  @media (max-width: 600px) {\n    .eg-overview {\n      padding: 24px;\n      margin-bottom: 24px;\n    }\n    .eg-overview h2 {\n      font-size: 1.5rem;\n    }\n    .eg-hero h1 {\n      font-size: 2rem;\n    }\n    .eg-subhead {\n      font-size: 1rem;\n    }\n  }\n  \n.eg-hero-header {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: center;\n    margin-top: 30px;\n  }\n  \n  .eg-info-icon {\n    font-size: 1.2rem;\n    color: #FFD000;\n    cursor: pointer;\n    transition: color .2s;\n  }\n  .eg-info-icon:hover {\n    color: #e6c000;\n  }\n  \n  /* Modal overlay */\n  .eg-modal-overlay {\n    position: fixed;\n    top: 0; left: 0;\n    width: 100%; height: 100%;\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n  }\n  \n  /* Modal box */\n  .eg-modal {\n    background: #fff;\n    border-radius: 8px;\n    padding: 32px;\n    max-width: 600px;\n    width: 90%;\n    position: relative;\n    box-shadow: 0 6px 24px rgba(0,0,0,0.2);\n    text-align: left;\n  }\n  \n  /* Close button */\n  .eg-modal-close {\n    position: absolute;\n    top: 12px; right: 12px;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #888;\n  }\n  .eg-modal-close:hover {\n    color: #333;\n  }\n  \n  /* Modal content */\n  .eg-modal h2 {\n    margin-top: 0;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #222;\n  }\n  .eg-modal p {\n    margin: 16px 0 0;\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #444;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
